import "./advertList.css";
import Posts from "../../components/Posts/Posts";
export default function AdvertList() {
  return (
    <div className="userList">
      <Posts />
    </div>
  );
}
